import { Box } from '@mui/material';
import Badge, { BadgeProps } from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useUpdateContactField } from '../../../sic-lib/api/hooks/useContact';
import { FieldValidationType } from '../../../sic-lib/enums/FieldValidationType';
import { buildUpdateContactField, ContactField } from '../../../sic-lib/types/ContactField';
import ContactFieldIcon from './ContactFieldIcon';

export default function ContactFieldIconContainer({ contactId, contactField }: Props) {
    const { mutate: updateContactField, error } = useUpdateContactField(contactId);

    const handleIsVerifiedToggle = async () => {
        const updateField = buildUpdateContactField({
            ...contactField,
            ...{
                fieldName: 'value',
                isVerified: !contactField.isVerified,
            },
        });
        updateContactField(updateField);
    };

    // isVerifable is controlled by custom fields page on website
    return (
        <Box>
            {contactField.isVerifiable &&
            (contactField.validationType === FieldValidationType.usMobilePhone ||
                contactField.validationType === FieldValidationType.email) ? (
                <IconButton
                    aria-label={contactField.validationType.toString()}
                    onClick={handleIsVerifiedToggle}
                >
                    <Tooltip
                        title={contactField.isVerified ? 'Verified' : 'Unverified'}
                        placement="left-start"
                        style={{ height: '80%', alignSelf: 'center' }}
                    >
                        <StyledBadge
                            badgeContent={contactField.isVerified ? '✓' : null}
                            color="success"
                        >
                            <ContactFieldIcon validationType={contactField.validationType} />
                        </StyledBadge>
                    </Tooltip>
                </IconButton>
            ) : (
                <IconButton aria-label={contactField.validationType.toString()} disabled>
                    <ContactFieldIcon validationType={contactField.validationType} />
                </IconButton>
            )}
        </Box>
    );
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        left: 0,
        top: 4,
        border: `1px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

interface Props {
    contactId: number;
    contactField: ContactField;
}
